var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThunderbolt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thunderbolt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M7.125 2.10352H4.93164L3.08008 5.30078H4.61719L4.02832 7.6543L7.15137 4.6748H5.09082L7.125 2.10352Z",
    fill: "#E6F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.61623 4.00879H6.46486L8.39944 1.56445C8.43947 1.5127 8.40334 1.4375 8.33791 1.4375H4.59279C4.56545 1.4375 4.53908 1.45215 4.52541 1.47656L1.99514 5.84668C1.96487 5.89844 2.00197 5.96387 2.06252 5.96387H3.76565L2.8926 9.45605C2.87404 9.53223 2.96584 9.58594 3.02248 9.53125L8.66994 4.14258C8.72072 4.09473 8.68654 4.00879 8.61623 4.00879ZM4.02834 7.65332L4.61721 5.2998H3.0801L4.93166 2.10254H7.12502L5.09084 4.67383H7.15139L4.02834 7.65332Z",
    fill: "#0996CE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderbolt);
export default __webpack_public_path__ + "static/media/thunderbolt.3f686596c8e9995f3c9f88f912ecb2dd.svg";
export { ForwardRef as ReactComponent };